import { MfoBankStatus } from '@/components/Shared/constants/banks-statuses';
import { Button } from '@/components/Shared/ui';
import InfoCircle from '@/media/svg/info-circle.svg?react';
import { useAppDispatch, useAppSelector } from '@/store';
import { onSetSelectedBank } from '@/store/financingStep.slice';
import { setCurrent } from '@/store/newOrder.slice';

import useSelectOffer from '../../../hooks/useSelectOffer';
import type { TBankOffers } from '../../../types/bank-offer.types';

const hideCancelButtonStatuses = [MfoBankStatus.Financed];

interface IProps {
  bankOffer: TBankOffers;
  setCancelModal: (value: boolean) => void;
  setOfferDetailsModal: (value: boolean | string) => void;
}

const useHeaderActions = ({
  bankOffer,
  setCancelModal,
  setOfferDetailsModal
}: IProps) => {
  const dispatch = useAppDispatch();

  const { handleSelect } = useSelectOffer({ bankOffer });
  const {
    userAccesses: {
      autoCredit: { canAcceptOffer, canCancelOffer }
    }
  } = useAppSelector((state) => state.userInfo);
  const { orderApp } = useAppSelector((state) => state.newOrder);
  const { selectedBank } = useAppSelector((state) => state.financingStep);

  const canAccept =
    bankOffer.status.code === MfoBankStatus.Approved ||
    bankOffer.status.code === MfoBankStatus.AcceptedAlternative;

  // Блокируем кнопки "Принять" и "Отклонить", если заявка создана клиентом
  // и текущий bankOffer не имеет статуса "Принято клиентом"
  const isButtonsDisabled = canAccept && orderApp?.isOnlineRequest;

  const headerActions: React.ReactElement[] = [];
  if (bankOffer.isOffered && bankOffer.status.code !== MfoBankStatus.Financed) {
    headerActions.push(
      <Button
        key={bankOffer.id + 'continue'}
        size="small"
        variant="filled-red"
        onClick={() => {
          if (!selectedBank) dispatch(onSetSelectedBank(bankOffer));
          dispatch(setCurrent(2));
        }}
      >
        Продолжить
      </Button>
    );
  }
  if (canAccept || bankOffer.status.code === MfoBankStatus.ClientAccepted)
    headerActions.push(
      <Button
        key={bankOffer.id + 'accept'}
        size="small"
        variant="filled-red"
        onClick={() => handleSelect()}
        disabled={isButtonsDisabled || !canAcceptOffer}
      >
        Принять <span className="offer-body__hidden">предложение</span>
      </Button>
    );
  if (
    !hideCancelButtonStatuses.includes(bankOffer.status.code as MfoBankStatus)
  ) {
    headerActions.push(
      <Button
        key={bankOffer.id + 'reject'}
        size="small"
        onClick={() => setCancelModal(true)}
        disabled={isButtonsDisabled || !canCancelOffer}
      >
        Отклонить
      </Button>
    );
  }

  if (bankOffer.bankDescription)
    headerActions.push(
      <Button
        key={bankOffer.id + 'description'}
        onClick={() => setOfferDetailsModal(true)}
        size="small"
      >
        <InfoCircle />
        Описание
      </Button>
    );

  return { headerActions };
};

export default useHeaderActions;
